module.exports = __webpack_public_path__ + "img/1 (146).7e4cd0ff.png";